export default {
	forStudent: 'For Student',
	windows: 'AirClass for Windows',
	mac: 'AirClass for Mac',
	iphone: 'AirClass for iPhone',
	android: 'AirClass for Android',
	download: 'Download',
	scan: 'Scan to download the iPhone client',
	scanA: 'Scan to download the android client',
	scan1: 'scan the code',
	toDownload: 'to download',
	newToDownload: 'for Android',
	or: 'or',
	clickHere: 'Click here',
	h2: 'AirClass 1-on-1',
	p: 'Deliver results quickly AirClass online tutoring',
	span1: 'Go to App Store',
	ios: 'IOS ',
	play: 'Go to Google Play',
	newPlay: 'Go to download',
	play1: 'Android',
	macTitle: 'MAC',
	windowsTitle: 'WINDOWS',
	forTeacher: 'For Teacher',
	guide: 'Download User Guide',
	pdf_url: 'https://web-data.zmlearn.com/doc/tWWwSu81Ucjdmadijv5XRu/App%20intstroduction.pdf',
};
